import * as React from 'react';
import { Tracking } from '@gjensidige/core-analytics'; // implemented as a singleton, exposes trackView, trackEvents and setOptions

const tracker = new Tracking({
  application_module: 'villkor-page',
  application_name: 'forsakringsvillkor',
  application_partner: 'gjensidige',
  business_area: 'insurance',
  scenario_name: 'forsakringsvillkor',
  scenario_start: '',
  scenario_step: ''
});

function usePageViews(page_pathname: string) {
  React.useEffect(() => {
    tracker.trackView({ page_pathname });
  }, [page_pathname]);
}
export { tracker, usePageViews };
